// src/Screens/admin/Marquee/MarqueeManagement.jsx
import React, { useState, useEffect, useContext } from "react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import {
  FiSearch,
  FiFilter,
  FiEdit2,
  FiTrash2,
  FiLink,
  FiEye,
  FiEyeOff,
  FiX,
  FiType,
  FiMessageSquare,
  FiCheckCircle,
  FiMinusCircle,
} from "react-icons/fi";
import { Form, Spinner } from "react-bootstrap";
import "../../../assets/css/admin/screens/marqueemanagement/AdminMarqueeManagement.css";
import axios from "axios";
import AppContext from "../../../contexts/AppContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MarqueeManagement = () => {
  const { baseUrl, adminAuthToken } = useContext(AppContext);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingMarquee, setEditingMarquee] = useState(false);
  const [marqueetext, setMarqueeText] = useState("");
  const [link, setLink] = useState("");
  const [status, setStatus] = useState("Active");
  const [marqueeid, setMarqueeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const [marquees, setMarquees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setMarqueeText("");
    setLink("");
    setStatus("Active");
    setMarqueeId("");
    setErrors({});
  };

  const createMarquee = () => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const adminId = loggedInAdmin?.id;
    const formdata = new FormData();
    formdata.append("chadmin_id", adminId);
    formdata.append("marqueetext", marqueetext);
    formdata.append("link", link);
    formdata.append("status", status);
    axios
      .post(`${baseUrl}/admin/marquee/createMarquee`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        console.log(response);
        toast.success("Marquee Created");
        viewAllMarquee();
        viewMarqueeStats();
        setLoading(false);
      })
      .catch((error) => console.log(error));
  };

  const updateMarquee = () => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const adminId = loggedInAdmin?.id;
    const formdata = new FormData();
    formdata.append("chadmin_id", adminId);
    formdata.append("marqueeid", marqueeid);
    formdata.append("marqueetext", marqueetext);
    formdata.append("link", link);
    formdata.append("status", status);
    axios
      .post(`${baseUrl}/admin/marquee/updateMarquee`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        console.log(response.data);
        toast.info("Marquee Updated");
        viewAllMarquee();
        viewMarqueeStats();
      })
      .catch((error) => console.log(error));
  };

  const viewAllMarquee = () => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const adminId = loggedInAdmin?.id;
    setLoading(true);
    axios
      .post(`${baseUrl}/admin/marquee/viewAllMarquee`, 
        { chadmin_id: adminId },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${adminAuthToken}`,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setMarquees(response.data.marquee);
        setLoading(false);
        handleCloseModal();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const deleteMarquee = (id) => {
    const formdata = new FormData();
    formdata.append("marqueeid", id);
    axios
      .post(`${baseUrl}/admin/marquee/deleteMarquee`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        console.log(response.data);
        toast.error("Marquee Deleted");
        viewAllMarquee();
        viewMarqueeStats();
      })
      .catch((error) => console.log(error));
  };

  const viewMarqueeStats = () => {
    axios
      .get(`${baseUrl}/admin/marquee/stats`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminAuthToken}`,
        },
      })
      .then((response) => setStats(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewAllMarquee();
    viewMarqueeStats();
  }, []);

  const handleCreateMarquee = () => {
    resetForm();
    setEditingMarquee(false);
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);
    resetForm();
  };

  const filteredMarquees = marquees.filter((m) => {
    const matchesSearch =
      m.marqueetext?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      m.link?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(m.id).includes(searchTerm);
    const matchesStatus =
      filterStatus === "All" || m.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const getStatusClass = (s) => {
    if (s === "Active") return "mrq-status--active";
    if (s === "Inactive") return "mrq-status--inactive";
    return "";
  };

  return (
    <AdminMasterLayout>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="mrq-card-shell">

        {/* ── Header ── */}
        <div className="mrq-header-section">
          <div>
            <h3 className="mrq-section-title">Marquee Management</h3>
            <p className="mrq-section-subtitle">Manage your website marquee announcements</p>
          </div>
          <button className="mrq-create-btn" onClick={handleCreateMarquee}>
            <span>+</span> Create New Marquee
          </button>
        </div>

        {/* ── Stat Cards ── */}
        <div className="mrq-summary-grid">
          <div className="mrq-summary-card">
            <div>
              <span className="mrq-label">Total Marquees</span>
              <h3>{stats?.total_marquees ?? "0"}</h3>
              <p className="mrq-muted mb-0">All announcements</p>
            </div>
            <div className="mrq-card-icon"><FiMessageSquare size={22} /></div>
          </div>
          <div className="mrq-summary-card">
            <div>
              <span className="mrq-label">Active</span>
              <h3>{stats?.active_marquees ?? "0"}</h3>
              <p className="mrq-muted mb-0">Currently visible</p>
            </div>
            <div className="mrq-card-icon mrq-card-icon--green"><FiCheckCircle size={22} /></div>
          </div>
          <div className="mrq-summary-card">
            <div>
              <span className="mrq-label">Inactive</span>
              <h3>{stats?.inactive_marquees ?? "0"}</h3>
              <p className="mrq-muted mb-0">Not showing</p>
            </div>
            <div className="mrq-card-icon mrq-card-icon--red"><FiMinusCircle size={22} /></div>
          </div>
        </div>

        {/* ── Toolbar ── */}
        <div className="mrq-toolbar">
          <div className="mrq-search-group">
            <span className="mrq-search-icon"><FiSearch size={14} /></span>
            <input
              className="mrq-search-input"
              placeholder="Search by text, link or ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="mrq-filter-group">
            <FiFilter size={14} />
            <select
              className="mrq-filter-select"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="All">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* ── Table ── */}
        <div className="mrq-layout">
          <div className="mrq-table-wrapper">
            <table className="mrq-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Marquee Text</th>
                  <th>Link</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="5" className="text-center py-4">
                      <Spinner animation="border" size="sm" className="mrq-spinner" />
                      <span className="ms-2 mrq-muted mrq-loading-text">Loading marquees...</span>
                    </td>
                  </tr>
                )}

                {!loading && filteredMarquees.length > 0 && filteredMarquees.map((marquee) => (
                  <tr key={marquee.id}>
                    <td><span className="mrq-id">#{marquee.id}</span></td>
                    <td><p className="mrq-text-content">{marquee.marqueetext}</p></td>
                    <td>
                      <a
                        href={marquee.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mrq-link-url"
                      >
                        <FiLink size={12} />
                        <span>{marquee.link}</span>
                      </a>
                    </td>
                    <td>
                      <span className={`mrq-status ${getStatusClass(marquee.status)}`}>
                        {marquee.status}
                      </span>
                    </td>
                    <td>
                      <div className="mrq-actions">
                        <button
                          className="mrq-action-btn mrq-action-btn--edit"
                          title="Edit"
                          onClick={() => {
                            setEditingMarquee(true);
                            setMarqueeId(marquee.id);
                            setMarqueeText(marquee.marqueetext);
                            setLink(marquee.link);
                            setStatus(marquee.status);
                            setShowCreateModal(true);
                          }}
                        >
                          <FiEdit2 size={13} />
                        </button>
                        {marquee.status === "Inactive" ? (
                          <button className="mrq-action-btn mrq-action-btn--activate" title="Activate">
                            <FiEye size={13} />
                          </button>
                        ) : (
                          <button className="mrq-action-btn mrq-action-btn--deactivate" title="Deactivate">
                            <FiEyeOff size={13} />
                          </button>
                        )}
                        <button
                          className="mrq-action-btn mrq-action-btn--delete"
                          title="Delete"
                          onClick={() => deleteMarquee(marquee.id)}
                        >
                          <FiTrash2 size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {!loading && filteredMarquees.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <div className="mrq-empty-icon">📢</div>
                      <p className="mrq-muted mt-2">
                        {marquees.length === 0 ? "No marquees found" : "No marquees match the selected filters"}
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Modal ── */}
      {showCreateModal && (
        <div className="mrq-modal-overlay" onClick={handleCloseModal}>
          <div className="mrq-modal-content" onClick={(e) => e.stopPropagation()}>

            {/* Modal Header */}
            <div className="mrq-modal-header">
              <h4>{editingMarquee ? "Edit Marquee" : "Create New Marquee"}</h4>
              <button className="mrq-modal-close" onClick={handleCloseModal}>
                <FiX size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="mrq-modal-body">
              <Form>
                <Form.Group className="mrq-form-group">
                  <label className="mrq-form-label">
                    <FiType size={14} /> Marquee Text <span className="mrq-required">*</span>
                  </label>
                  <textarea
                    value={marqueetext}
                    onChange={(e) => setMarqueeText(e.target.value)}
                    placeholder="Enter your marquee announcement text here..."
                    className={`mrq-form-control mrq-textarea${errors.text ? " mrq-invalid" : ""}`}
                    rows={3}
                  />
                  {errors.text && <span className="mrq-error-text">{errors.text}</span>}
                  <small className="mrq-char-count">{marqueetext.length}/200 characters</small>
                </Form.Group>

                <Form.Group className="mrq-form-group">
                  <label className="mrq-form-label">
                    <FiLink size={14} /> Link URL <span className="mrq-required">*</span>
                  </label>
                  <input
                    type="text"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    placeholder="https://example.com/your-link"
                    className={`mrq-form-control${errors.link ? " mrq-invalid" : ""}`}
                  />
                  {errors.link && <span className="mrq-error-text">{errors.link}</span>}
                  <small className="mrq-help-text">Enter the full URL where users will be redirected</small>
                </Form.Group>

                <Form.Group className="mrq-form-group">
                  <label className="mrq-form-label">Status</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="mrq-form-control"
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  <small className="mrq-help-text">
                    {status === "Active"
                      ? "This marquee will be visible on the website"
                      : "This marquee will be hidden from the website"}
                  </small>
                </Form.Group>

                <div className="mrq-modal-footer">
                  <button type="button" className="mrq-btn-cancel" onClick={handleCloseModal}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="mrq-btn-save"
                    onClick={() => { editingMarquee ? updateMarquee() : createMarquee(); }}
                  >
                    {editingMarquee ? "Update Marquee" : "Create Marquee"}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </AdminMasterLayout>
  );
};

export default MarqueeManagement;